import { render, staticRenderFns } from "./el-pagination.vue?vue&type=template&id=4e0540c0&scoped=true"
import script from "./el-pagination.vue?vue&type=script&lang=js"
export * from "./el-pagination.vue?vue&type=script&lang=js"
import style0 from "./el-pagination.vue?vue&type=style&index=0&id=4e0540c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0540c0",
  null
  
)

export default component.exports